const isPupillaryDistance = (param) => param.name === "pupillaryDistance";
const isAxis = (param) => param.name === "axis";
const isCylinder = (param) => param.name === "cylinder";
export {
  isAxis,
  isCylinder,
  isPupillaryDistance
};
//# sourceMappingURL=parameter-type-guards.js.map
